import logo from "../../Images/aadyacolourlogo.png";


export const exportToPrint = (studentRecords, className, section) => {
  const printWindow = window.open("", "_blank");
  if (!printWindow) return alert("Popup blocked. Please allow popups for this site.");

  const getStudentHTML = (student) => {
    const scholasticRows = Object.entries(student.scholastic || {}).flatMap(
      ([subject, assessments]) =>
        Object.entries(assessments || {}).map(
          ([spec, data]) => `
          <tr>
            <td>${subject}</td>
            <td>${spec}</td>
            <td>${data?.max_marks ?? 0}</td>
            <td>${data?.scored ?? 0}</td>
            <td>${data?.total ?? 0}</td>
            <td>${data?.grade ?? "N/A"}</td>
          </tr>`
        )
    ).join("");

    const observationRows = Object.entries(student.observation || {}).map(
      ([obs, grade]) => `<tr><td>${obs}</td><td>${grade}</td></tr>`
    ).join("");

    const coScholasticRows = Object.entries(student.co_scholastic || {}).map(
      ([subject, marks]) => `<tr><td>${subject}</td><td>${marks}</td></tr>`
    ).join("");

    return `
      <div class="student-form">
        <div class="header">
          <img src="${AadyaLogo}" class="logo" />
          <div style="text-align: center; font-size: 20px; font-weight: bold; color: #ff6600; margin: 10px 0;">
            Unit Test (2024-25)
          </div>
        </div>

        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
  <div style="font-size: 14px;">
    <strong>Name:</strong> ${student.name || "N/A"}<br/>
    <strong>Grade / Section:</strong> ${student.class || "N/A"}
  </div>
  <div style="font-size: 16px; font-weight: bold; ">
    Scholastic 
  </div>
</div>


        
        <table>
          <thead>
            <tr>
              <th>Subjects</th>
              <th>Assessment Spec</th>
              <th>Max Marks</th>
              <th>Scored</th>
              <th>Total</th>
              <th>Grade</th>
            </tr>
          </thead>
          <tbody>
            ${scholasticRows || "<tr><td colspan='6'>No data available</td></tr>"}
          </tbody>
        </table>

        <div class="side-by-side">
          <div>
            <h3>Observation</h3>
            <table>
              <thead><tr><th>Observation</th><th>Grade</th></tr></thead>
              <tbody>
                ${observationRows || "<tr><td colspan='2'>No data</td></tr>"}
              </tbody>
            </table>
          </div>
          <div>
            <h3>Co-Scholastic</h3>
            <table>
              <thead><tr><th>Co-Scholastic</th><th>Marks Scored</th></tr></thead>
              <tbody>
                ${coScholasticRows || "<tr><td colspan='2'>No data</td></tr>"}
              </tbody>
            </table>
          </div>
        </div>

        <div class="remarks"><strong>Remarks:</strong> ${student.remarks || ""}</div>
      </div>
    `;
  };

  const content = `
    <html>
      <head>
        <title>Student Report</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 30px; }
          .student-form { border: 1px solid #ccc; padding: 20px; margin-bottom: 30px; }
          .logo { height: 50px; }
          .header { display: flex; align-items: center; gap: 20px; margin-bottom: 20px; }
          .school-name { font-size: 20px; font-weight: bold; color: #ff6600; }
          .details { margin-bottom: 20px; font-size: 14px; }
          table { width: 100%; border-collapse: collapse; margin-top: 10px; margin-bottom: 20px; }
          th, td { border: 1px solid #888; padding: 6px; text-align: center; font-size: 13px; }
          th { background-color: #f2f2f2; }
          .remarks { margin: 10px 0; font-size: 14px; }

          .side-by-side {
            display: flex;
            justify-content: space-between;
            gap: 20px;
            margin-top: 20px;
          }
          .side-by-side > div {
            width: 48%;
          }
        </style>
      </head>
      <body>
        ${studentRecords.map(getStudentHTML).join("")}
      </body>
    </html>
  `;

  printWindow.document.write(content);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};
